var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useMap } from 'react-map-gl';
import { MapButton } from '../MapButton';
/**
 * The `FullscreenButton` toggles the map full-screen when clicked.
 * The current map ViewState must be passed to this control.
 *
 * @example
 * ```tsx
 * <FullscreenButton {...this.state.viewState} x={40} y={200} hint={<>Toggle full screen</>}/>
 * ```
 */
var FullscreenButton = function (p) {
    var map = useMap().current;
    //
    // Does the browser offer full screen support?
    var checkFullscreenSupport = function () {
        return !!(window.document.fullscreenEnabled ||
            window.document.webkitFullscreenEnabled);
    };
    var toggle = function () {
        if (document.fullscreenElement === null) {
            map.getContainer().requestFullscreen();
        }
        else {
            window.document.exitFullscreen();
        }
    };
    return (React.createElement(MapButton, __assign({ disabled: !checkFullscreenSupport(), onClick: toggle }, p),
        React.createElement("svg", { width: "100", height: "100", viewBox: "0 0 448 512", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z" }))));
};
export { FullscreenButton };
